/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: 'administration',
        title: 'Administración',
        type: 'group',
        icon: 'heroicons_outline:home',
        roles: ['Admin'],
        children: [
            {
                id: 'administration.users',
                title: 'Usuarios',
                type: 'basic',
                icon: 'heroicons_outline:users',
                link: '/dashboards/users',
            },
            {
                id: 'administration.enterprises',
                title: 'Empresas',
                type: 'basic',
                icon: 'mat_outline:business_center',
                link: '/dashboards/enterprises',
            },
            {
                id: 'administration.types_devices',
                title: 'Tipos de dispositivos',
                type: 'basic',
                icon: 'mat_outline:devices_other',
                link: '/dashboards/types_devices',
            },
            {
                id: 'administration.types_plans',
                title: 'Periodos de licencias',
                type: 'basic',
                icon: 'mat_outline:folder_special',
                link: '/dashboards/types_plans',
            },
            {
                id: 'administration.devices',
                title: 'Dispositivos',
                type: 'basic',
                icon: 'mat_outline:devices',
                link: '/dashboards/devices',
            },
            {
                id: 'administration.license_payment',
                title: 'Historial de Ventas',
                type: 'basic',
                icon: 'mat_outline:payments',
                link: '/dashboards/license_payment',
            },
        ],
    },
    {
        id: 'development',
        title: 'Desarrollo',
        type: 'group',
        icon: 'heroicons_outline:chart-pie',
        roles: ['Developer'],
        children: [
            {
                id: 'administration.projects',
                title: 'Proyectos',
                type: 'basic',
                icon: 'heroicons_outline:briefcase',
                link: '/dashboards/projects',
            },
            {
                id: 'administration.publications',
                title: 'Publicaciones',
                type: 'basic',
                icon: 'heroicons_outline:newspaper',
                link: '/dashboards/publications',
            },
        ],
    },
    {
        id: 'gestion',
        title: 'Manager',
        type: 'group',
        icon: 'heroicons_outline:face-smile',
        roles: ['Manager'],
        children: [
            {
                id: 'gestion.divisions',
                title: 'Divisiones',
                type: 'basic',
                icon: 'mat_outline:filter_list',
                link: '/dashboards/divisions',
                classes: {
                    icon: 'invert-icon'
                }
            },
            {
                id: 'gestion.users',
                title: 'Usuarios',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: '/dashboards/users_manager',
            },
            {
                id: 'gestion.devices',
                title: 'Dispositivos',
                type: 'basic',
                icon: 'mat_outline:devices',
                link: '/dashboards/assign_devices',
            },
            {
                id: 'gestion.history_sale',
                title: 'Historial de Compras',
                type: 'basic',
                icon: 'mat_outline:payments',
                link: '/dashboards/shopping_history',
            },
            // {
            //     id: 'gestion.events',
            //     title: 'Eventos',
            //     type: 'basic',
            //     icon: 'mat_outline:event',
            //     link: '/dashboards/events',
            // },
        ],
    },
    {
        id: 'coach',
        title: 'Entrenador',
        type: 'group',
        icon: 'heroicons_outline:face-smile',
        roles: ['Coach'],
        children: [
            {
                id: 'coach.users',
                title: 'Jugadores',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: '/dashboards/users_coach',
            },
            {
                id: 'coach.devices',
                title: 'Dispositivos',
                type: 'basic',
                icon: 'mat_outline:devices',
                link: '/dashboards/coach_devices',
            },
            {
                id: 'coach.cluster',
                title: 'Acomodos',
                type: 'basic',
                icon: 'heroicons_outline:squares-2x2',
                link: '/dashboards/cluster',
            },
            {
                id: 'coach.routines',
                title: 'Rutinas',
                type: 'basic',
                icon: 'mat_outline:cycle',
                link: '/dashboards/routines',
            },
            {
                id: 'coach.routine_detonator',
                title: 'Entrenamientos',
                type: 'basic',
                icon: 'mat_outline:router',
                link: '/dashboards/routine_detonator',
                classes: {
                    wrapper: 'highlight-routines'
                }
            },
            /*{
                id: 'gestion.stats',
                title: 'Estadísticas',
                type: 'basic',
                icon: 'heroicons_outline:chart-pie',
                link: '/dashboards/coach_stats',
            },*/
            {
                id: 'coach.manual',
                title: 'Modo Manual',
                type: 'basic',
                icon: 'mat_outline:control_camera',
                link: '/dashboards/manual',
            },
            {
                id: 'coach.metrics',
                title: 'Resultados',
                type: 'basic',
                icon: 'heroicons_outline:chart-bar',
                link: '/dashboards/routine_comparator',
            },
        ],
    },
    {
        id: 'marketing',
        title: 'Marketing',
        type: 'group',
        icon: 'heroicons_outline:face-smile',
        roles: ['Marketing'],
        children: [
            {
                id: 'marketing.report',
                title: 'Listado de pedidos',
                type: 'basic',
                icon: 'heroicons_outline:presentation-chart-line',
                link: '/dashboards/sales_report',
            },
            {
                id: 'marketing.config',
                title: 'Configuración',
                type: 'basic',
                icon: 'heroicons_outline:cog',
                link: '/dashboards/configuration',
            },
        ],
    },
    {
        id: 'marketing.products',
        title: 'Productos',
        type: 'group',
        icon: 'heroicons_outline:face-smile',
        roles: ['Marketing'],
        children: [
            {
                id: 'marketing.products.inventory',
                title: 'Inventario',
                type: 'basic',
                icon: 'heroicons_outline:building-storefront',
                link: '/dashboards/inventory',
            },
            {
                id: 'marketing.products.category',
                title: 'Categorías',
                type: 'basic',
                icon: 'heroicons_outline:tag',
                link: '/dashboards/products_category',
            },
            {
                id: 'marketing.products.brands',
                title: 'Marcas ',
                type: 'basic',
                icon: 'heroicons_outline:fire',
                link: '/dashboards/products_brands',
            },
        ],
    },
    {
        id: 'staff',
        title: 'Staff',
        type: 'group',
        icon: 'heroicons_outline:face-smile',
        roles: ['Staff'],
        children: [
            {
                id: 'staff.events.manage',
                title: 'Activar rutinas',
                type: 'basic',
                icon: 'mat_outline:event',
                link: '/dashboards/manage-events',
            },
            {
                id: 'staff.events.results',
                title: 'Resultados',
                type: 'basic',
                icon: 'mat_outline:receipt',
                link: '/dashboards/results-events',
            },
            {
                id: 'staff.events.manage-participants',
                title: 'Gestionar participantes',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: '/dashboards/manage-participants',
            },
        ],
    },
    // {
    //     id: 'player',
    //     title: 'Jugador',
    //     type: 'group',
    //     icon: 'heroicons_outline:face-smile',
    //     roles: ['Player'],
    //     children: [
    //         {
    //             id: 'player.routines.statistics',
    //             title: 'Ver mis estadísticas',
    //             type: 'basic',
    //             icon: 'heroicons_outline:chart-pie',
    //             link: '/dashboards/player-statistics',
    //         },
    //         {
    //             id: 'player.routines.detonate',
    //             title: 'Detonar rutina',
    //             type: 'basic',
    //             icon: 'mat_outline:cycle',
    //             link: '/dashboards/player-routine-detonate',
    //         },
    //     ],
    // },
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboards',
        title: 'Dashboards',
        tooltip: 'Dashboards',
        type: 'aside',
        icon: 'heroicons_outline:chart-pie',
        //link : '/example'
        children: [],
    }
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example'
    }
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example'
    }
];
